const messages = {
  step3: {
    actionBtn: "Вход",
  },
};

export default {
  messages,
};
